import React, { ReactChild } from 'react'
import { Icon, IconType } from '..'
import cn from 'classnames'

export type InputType = 'text' | 'select'

type Props = {
  containerClass?: string
  className?: string
  appendIcon?: IconType
  label?: string
  col?: boolean
  onRenderButton?: () => ReactChild
  tight?: boolean
}

const Input: React.FC<Props & React.HTMLProps<HTMLInputElement>> = ({
  containerClass,
  className,
  appendIcon,
  label,
  col,
  onRenderButton,
  tight = false,
  ...rest
}) => {
  return (
    <div
      className={cn('position-relative d-flex flex-column flex-lg-row', {
        'mt-2': label,
        'flex-lg-column': tight
      })}
    >
      <div className={cn('position-relative', containerClass)}>
        <input className={cn('input parag--sm', className)} {...rest} />
        {appendIcon && <Icon type={appendIcon} containerClass='input-icon' />}
      </div>
      {onRenderButton ? onRenderButton() : null}
    </div>
  )
}

export default Input
